var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 35,
    viewBox: "0 0 30 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x80\x94\xC3\x8E\xC3\x93\xC3\x88 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 34.1918C23.2843 34.1918 30 26.5377 30 17.0959C30 7.65409 23.2843 0 15 0C6.71573 0 0 7.65409 0 17.0959C0 26.5377 6.71573 34.1918 15 34.1918Z",
    fill: "#58B0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2888 21.4003L19.0107 21.4673V28.6144L11.2888 28.5474V21.4003Z",
    fill: "#F9DCA4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3452 32.5901C19.3824 33.632 17.2453 34.1783 15.0801 34.1916C12.9149 34.205 10.7727 33.6851 8.80005 32.6675V26.7874H21.3448L21.3452 32.5901Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.215 34.1366C15.8144 34.1731 15.4094 34.1916 15 34.192C14.6909 34.192 14.3843 34.1814 14.0801 34.1604L14.5801 29.1877H15.75L16.215 34.1366Z",
    fill: "#E9573E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4551 33.933C10.8012 33.5819 9.20402 32.9454 7.71863 32.0452C6.29191 31.1404 5.00374 29.9772 3.90454 28.6011L4.52784 26.886L11.2876 23.4491C11.2876 26.3328 12.1182 30.9077 12.4551 33.933Z",
    fill: "#677079"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.11,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0122 21.4441V23.2317C16.7151 26.2896 12.3263 25.857 11.3423 21.344L19.0122 21.4441Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1111 4.66501C25.4417 4.66501 21.4154 24.1765 15.1111 24.1765C9.15618 24.1765 4.78044 4.66501 15.1111 4.66501Z",
    fill: "#FFE8BE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91501 13.3038C7.42472 14.0446 8.69171 17.5562 9.62958 17.5407C9.24056 16.1668 9.00058 14.7442 8.91501 13.3038Z",
    fill: "#F9DCA4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4275 13.3033C22.9178 14.0441 21.6508 17.5562 20.7134 17.5402C21.1021 16.1663 21.3419 14.7435 21.4275 13.3033Z",
    fill: "#F9DCA4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6461 7.9272C9.02762 9.8404 9.59704 15.1363 9.59704 15.1363L9.08733 14.8624C5.90576 0.812745 24.4437 0.812191 21.2442 14.8624L20.7345 15.1363C20.7345 15.1363 21.3044 9.8404 19.6859 7.9272C17.6864 10.1375 12.6344 10.1259 10.6461 7.9272Z",
    fill: "#464449"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8481 33.8838C21.1284 33.1618 24.1028 31.2109 26.2987 28.3411L25.7695 26.8855L19.0103 23.4486C19.0103 26.3322 18.185 30.8585 17.8481 33.8838Z",
    fill: "#677079"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0109 23.2261L15.1633 26.803L18.3541 30.0745C18.3541 30.0745 19.2046 24.7056 19.0109 23.2261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.288 23.2261L15.1661 26.803L11.9404 30.0745C11.9404 30.0745 11.0928 24.7056 11.288 23.2261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.645 28.3422L15.1678 26.7831L16.6907 28.3422L15.1678 29.9008L13.645 28.3422Z",
    fill: "#E9573E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5083 33.9556C11.8885 33.8374 11.2758 33.6748 10.6738 33.4687C10.655 33.4521 10.6365 33.435 10.6185 33.4173L8.90248 29.8819L11.1069 28.0782H8.80005L9.29374 24.2878L11.2889 22.8499C11.3753 26.9274 12.1428 31.5118 12.5083 33.9556Z",
    fill: "#434955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7886 33.8964C18.074 33.8422 18.3565 33.7669 18.6366 33.6839C18.9677 33.586 19.2968 33.4753 19.624 33.3636L19.6891 33.3398L21.3934 29.8459L19.1891 28.0522H21.4959L21.0022 24.2806L19.007 22.8499C18.9206 26.9064 18.1536 31.4648 17.7886 33.8964Z",
    fill: "#434955"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo5);
export default __webpack_public_path__ + "static/media/logo5.8a1cd0b3a6764875777a05dd3f803dec.svg";
export { ForwardRef as ReactComponent };